import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import videoFile from './v1.mp4';

function FeaturedFilm() {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0%', 'end end'],
  });

  const headingTransform = useTransform(
    scrollYProgress,
    (v) => `perspective(1200px) scale(${1 - v * 0.2})`
  );

  const videoTransform = useTransform(
    scrollYProgress,
    (v) => `perspective(1200px) scale(${0.5 + v * 0.6})`
  );

  return (
    <section
      id="films"
      ref={ref}
      className="relative bg-[#421B03] text-white min-h-[80vh] sm:min-h-[200vh] overflow-visible p-5 z-10"
    >
      <div className="sticky top-0 w-full h-screen overflow-visible z-[1] flex-1 flex items-center flex-row	flex-nowrap	">
        {/* Sticky Heading */}
        <div className="contents">
          <motion.div
            style={{ transform: headingTransform }}
            className="absolute top-0 left-0 right-0 text-center py-6 sm:p-6"
          >
            <h2 className="font-cinzel uppercase font-extrabold tracking-tight text-[46px] sm:text-[70px] md:text-[80px] lg:text-[140px] 2xl:text-[160px] leading-[100%] bg-[linear-gradient(132deg,_#ffffff_11.68%,_rgba(0,0,0,0)_100%)] bg-clip-text text-transparent">
              FEATURED FILM
            </h2>
          </motion.div>
        </div>

        {/* Scaled Video - non-sticky */}
        <div className="contents">
          <motion.div
            style={{ transform: videoTransform }}
            className="sticky top-0 left-0 right-0  w-[1px] sm:max-w-[700px] lg:max-w-[930px] xl:max-w-[1240px] 2xl:max-w-[1380px] h-screen aspect-video rounded-xl overflow-hidden shadow-xl z-[1] flex-1 flex items-center flex-row	flex-nowrap	mx-auto"
          >
            <video
              src={videoFile}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover rounded-xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedFilm;
